export const euro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("it-IT"); } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("it-IT"); } catch { return iso; }
};

export const productLabel = (products, id) => products.find((p) => p.id === id)?.name || "—";
export const supplierLabel = (suppliers, id) => suppliers.find((s) => s.id === id)?.name || "—";
